// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".mask[data-v-09fa9859]{z-index:1000;top:0;right:0;left:0;bottom:0;background-color:rgba(0,0,0,.5)}.mask[data-v-09fa9859],.popup_box[data-v-09fa9859]{position:fixed;transition:all .6s}.popup_box[data-v-09fa9859]{z-index:1001;opacity:0;font-size:14px}.popup_bottom[data-v-09fa9859]{left:0;bottom:0;min-width:100%;transform:translateY(100%)}.popup_center[data-v-09fa9859]{left:50vw;top:50%;transform:translateX(-50%) translateY(-50%)}", ""]);
// Exports
module.exports = exports;
